'use client';
import { ComboBox, type ComboboxProps } from '@components/ui';
import { Field, type FieldProps } from './field';
import {
  Controller,
  type Control,
  type FieldErrors,
  type UseFormRegister,
} from 'react-hook-form';
import { Field as ChakraField } from '@chakra-ui/react';

interface FormComboBoxProps
  extends
    Omit<ComboboxProps, 'onSelect'>,
    Omit<FieldProps, keyof ComboboxProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  getEntireItem?: boolean;
  showLabelAtTop?: boolean;
}

const FormComboBox = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  helperText,
  items,
  getEntireItem = false,
  isShowLabel = true,
  labelProps,
  disableLabel = false,
  showLabelAtTop = false,
  required = false,
  ...rest
}: FormComboBoxProps) => {
  return (
    <Field
      label={!showLabelAtTop ? label : undefined}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      helperText={helperText}
      disabled={disabled}
      isShowLabel={isShowLabel}
      disableLabel={disableLabel}
      labelProps={labelProps}
      required={required}
    >
      {showLabelAtTop && label && (
        <ChakraField.Label mb={2} color="tertiary.fg">
          {label} <ChakraField.RequiredIndicator />
        </ChakraField.Label>
      )}
      <Controller
        control={control}
        name={id}
        render={({ field }) => (
          <ComboBox
            {...rest}
            items={items ?? []}
            onSelect={(value) => field.onChange(value)}
            onBlur={() => field.onBlur()}
            getEntireItem={getEntireItem}
            placeholder={`Search ${label || id}`}
            disabled={disabled}
            defaultValue={field.value}
          />
        )}
      />
    </Field>
  );
};

export default FormComboBox;
